module.exports = __webpack_public_path__ + "img/characters30On.dbe1967e.svg";